/*
 * @author: liqian
 * @date: Do not Edit
 * @description:
 */
import Vue from 'vue'
import Router from 'vue-router'
import router from '@/router'
import store from '../store'; // 导入 Vuex store
import { rememberPreviousRoute } from '@/views/modules/afterSale/aftersale/utils/aftersaleUiUtils.js'

Vue.use(Router)
//初始路由
export default new Router({
  base: '/',
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/views/index'),
      children: [
        {
          path: '/',
          name: 'home',
          meta: {requiresAuth: true},
          component: () => import('@/views/modules/home/home')
        },
        {
          path: '/404',
          name: '404',
          component: () => import('@/views/system/404/404')
        },
        {
          path: '/403',
          name: '403',
          component: () => import('@/views/system/404/403')
        },
      ]
    },
    // 以下白名单路由
    {
      path: '/login',
      name: 'login',
      //redirect: to => ({ path: '/login', query: { ...to.query, redirect: to.path } }),
      component: () => import('@/views/system/user/login')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/system/user/register')
    },
    {
      path: '/resetPasswordByEmail',
      name: 'resetPasswordByEmail',
      component: () => import('@/views/system/user/resetPasswordByEmail')
    },
    {
      path: '/resetPasswordByMobile',
      name: 'resetPasswordByMobile',
      component: () => import('@/views/system/user/resetPasswordByMobile')
    },
    {
      path: '/overdueReset',
      name: 'overdueReset',
      component: () => import('@/views/system/user/overdueReset')
    },
    {
      path: '/cloudIndex',
      name: 'cloudIndex',
      component: () => import('@/views/cloud/cloudIndex')
    },
  ],

});

//自定义添加路由方法,防止重复添加路由
router.$addRoutes = (params) => {
  router.matcher = new Router({mode: 'history'}).matcher;
  router.addRoutes(params)
}

// 动态路由是否已加载的标记
let dynamicRoutesLoaded = false
let dynamicRoutesLoadingPromise = null

// 加载动态路由（菜单驱动的路由 + CRM wujie 容器路由）
function loadDynamicRoutes() {
  if (dynamicRoutesLoaded) {
    return Promise.resolve()
  }
  if (dynamicRoutesLoadingPromise) {
    return dynamicRoutesLoadingPromise
  }
  dynamicRoutesLoadingPromise = import('../../static/js/menu.js').then(({ menuRoot }) => {
    if (menuRoot.loadedRouters) {
      dynamicRoutesLoaded = true
      return
    }
    return menuRoot.initMenuDate().then(function () {
      dynamicRoutesLoaded = true
    })
  }).finally(function () {
    dynamicRoutesLoadingPromise = null
  })
  return dynamicRoutesLoadingPromise
}

router.beforeEach(async (to, from, next) => {
  console.info("to:", to, "from:", from)

  const token = sessionStorage.getItem('access_token');

  if (to.matched.length === 0) {
    // 未登录时动态路由尚未加载，应跳转登录页而非 404
    if (!token) {
      console.info("non-login, redirect to login")
      next({
        path: '/login',
        query: {...to.query, redirect: to.path}
      });
      return;
    }
    // 路由未匹配 —— 可能是动态路由（含 CRM 菜单）还未加载
    if (!dynamicRoutesLoaded) {
      try {
        await loadDynamicRoutes()
        // 动态路由加载完成后，重新匹配目标路由
        if (router.resolve(to.fullPath).route.matched.length > 0) {
          next({ ...to, replace: true })
          return
        }
      } catch (e) {
        console.error('[router] 加载动态路由失败:', e)
      }
    }
    // 确实没有匹配的路由，导航到 404 页面
    console.info("未找到对应路由", to)
    next({path: '/404', query: {pathMatch: to.fullPath}});
    return;
  }

  const isAuthRequired = to.meta.requiresAuth;
  // 1。如果不需要鉴权，直接放行
  if (!isAuthRequired) {
    next();
    return;
  }
  // 2。如果用户未登录，重定向到登录页面并保留查询参数
  if (!token) {
    console.info("non-login")
    next({
      path: '/login',
      query: {...to.query, redirect: to.path}
    });
    return;
  }
  next();
});

// 登录成功后清除 redirectedFrom
router.afterEach((to, from) => {
  // 记录站内来源，供售后等详情页“从哪进回哪”
  rememberPreviousRoute(from)
  getBreadcrumbs(to); // 获取面包屑
});


function getBreadcrumbs(to) {
  if (store.state && store.state.publics.menuList) {
    const menuList = store.state.publics.menuList;
    const breadcrumbData = findBreadcrumbs(menuList, to.path, to.meta.parent);
    store.commit('SET_BREADCRUMB', breadcrumbData);
  }
}

function findBreadcrumbs(menus, targetUrl, parentPath) {
  const _breadcrumb = store.state.publics.breadcrumb;
  const breadcrumbs = [];

  function findParent(menus, url) {
    for (let i = 0; i < menus.length; i++) {
      const menu = menus[i];

      // 如果当前节点的 URL 与目标 URL 匹配
      if (menu.url === url) {
        // 收集当前节点的名称
        breadcrumbs.push(menu.menuName);

        // 如果当前节点不是顶级节点，则递归查找其父节点
        if (menu.parentId !== '-1') {
          const parent = menus.find(m => m.menuId === menu.parentId);
          if (parent) {
            // 递归查找父节点
            findParent(menus, parent.url);
          }
        }
        break;
      }
    }
  }

  // 开始查找
  // findParent(menus, targetUrl);
  // if (breadcrumbs.length === 0) {
  //   return _breadcrumb;
  // } else if (parentPath)  {
  //   const _breadcrumb = findParent(menus, parentPath);
  //   console.info(_breadcrumb)
  // }
  /*
   没有通过菜单配置的路由跳转面包屑问题解决
  * */
  let url = targetUrl;
  if (parentPath) {
    url = parentPath;
  }

  findParent(menus, url);
  if ("/modules/home/home" !== url) {
    breadcrumbs.push("首页");
  }
  return breadcrumbs.slice().reverse();
}



// WEBPACK FOOTER //
// ./src/router/index.js